import { action } from 'easy-peasy';
import { IActionSetCurrentClientOption } from '../types';

const setCurrentClientOption: IActionSetCurrentClientOption = action((state, payload) => {
  state.clientOptionsByTeam.current = payload;
});

export default setCurrentClientOption;
